<template>

<div class="row" :class="{'is-selected': isSelected, 'is-clickable': isClickable}" v-on:click="onClick">

    <slot></slot>

</div>

</template>

<script>

export default {

    props: ['isSelected', 'isClickable'],

    methods: {

        onClick: function() {

            if(this.isClickable) this.$emit('click')

        }

    }

}

</script>

<style scoped>

.row {
    display: grid;
}

.row:nth-child(even) {
	background-color: rgba(12, 137, 178, 0.05);
}

.row.is-selected:after {
    content: '';
    display: block;
    position: absolute;
    width: 0px;
    z-index: 2;
    height: 0px;
    right: -10px;
    top: 50%;
    margin-top: -10px;
    border-style: solid;
    border-width: 10px 0 10px 10px;
    border-color: transparent transparent transparent #ffeccf;
    transform: rotate(0deg);
}

.is-small-mobile .row.is-selected:after {
    display: none;
}

.row.is-clickable {
    cursor: pointer;
}

.row.is-clickable:hover {
   background-color: rgba(12, 137, 178, 0.25)!important;
   border-color: #fff;
}

.row.is-selected,
.row.is-selected:hover {
    background-color: #ffeccf!important;
}

</style>